import React, { memo, useCallback } from 'react'
import { Box } from '@chakra-ui/core'
import { useDispatch } from 'react-redux'
import { CommentInput } from 'components/Comments'
import { IHandleCreateComment } from 'constants/interfaces'
import keys from 'constants/keys'
import { setCommentsCounter } from 'redux/actions/comments'
import useComments from 'hooks/useComments'
import { Post } from 'redux/reducers/feed'

interface IProps {
  post: Post
  isInputFocus: boolean
  commentsCounter: number
}

export const PostModalFooter = memo(({ post, isInputFocus, commentsCounter }: IProps) => {
  const dispatch = useDispatch()
  const { sendComment, sendCommentLoading } = useComments(post.post_id)

  const handleCreateComment = useCallback(
    async ({ comment, images, videos, audios, files }: IHandleCreateComment) => {
      const isResponseOk = await sendComment({
        id: post.post_id,
        comment,
        rasID: post.ras_id || '',
        createdByUserId: post.created_by,
        images,
        videos,
        audios,
        files,
        objectType: keys.COMMENT_OBJECT_TYPE.COMMNET_ON_POST,
        ...(post.type === keys.POST_TYPE.GROUP_POST ? { is_update_post: true } : {}),
      })
      if (isResponseOk) {
        dispatch(setCommentsCounter({ count: commentsCounter + 1, key: post.post_id }))
      }
    },
    [post, sendComment, dispatch, commentsCounter]
  )

  return (
    <Box w="100%">
      <CommentInput
        isFocused={isInputFocus}
        postID={post.post_id}
        handleCreateComment={handleCreateComment}
        sendCommentLoading={sendCommentLoading}
      />
    </Box>
  )
})
